export const LogoShield = ({ height = 40, className = "" }) => (
  <img
    src="/logo_shield.png"
    alt="Logo officiel B.KOSS"
    style={{ height }}
    className={`w-auto ${className}`}
    draggable={false}
  />
);

export const LogoFull = ({ className = "h-24" }) => (
  <img
    src="/logo.png"
    alt="B.KOSS — La Marque Des Grands Hommes"
    className={`w-auto ${className}`}
    draggable={false}
  />
);

export const LogoMark = ({ size = 40 }) => <LogoShield height={size} />;

export const Logo = ({ compact = false }) => (
  <span className="inline-flex items-center gap-3">
    <LogoShield height={compact ? 34 : 46} />
    {!compact && (
      <span className="flex flex-col leading-none">
        <span className="font-serif text-xl tracking-[0.18em] text-ivoire">B.KOSS</span>
        <span className="mt-1 font-mono text-[8px] uppercase tracking-[0.28em] text-or">
          La Marque Des Grands Hommes
        </span>
      </span>
    )}
  </span>
);
